// extracted by mini-css-extract-plugin
export default {"balanceBlock":"BalanceBlock_balanceBlock__aSPjz"};